export default __webpack_public_path__ + "static/media/eduImgBlack.8ee2e691.svg";